import type { EvidenceStatus } from '../models/fundraising-comparison.models';

const EVIDENCE_BADGE_CLASSES: Record<EvidenceStatus, string> = {
  'verified-formula':
    'bg-primary-subtle text-primary-emphasis border-primary-subtle',
  'published-average': 'bg-info-subtle text-info-emphasis border-info-subtle',
  'published-regional-pricing':
    'bg-warning-subtle text-warning-emphasis border-warning-subtle',
  'example-proposal':
    'bg-secondary-subtle text-secondary-emphasis border-secondary-subtle',
  'user-assumption': 'bg-light text-body border-dark',
};

export function evidenceBadgeClasses(status: EvidenceStatus): string {
  return EVIDENCE_BADGE_CLASSES[status];
}
